import { render } from "./TeamAgencyPermission.vue?vue&type=template&id=b1925938"
import script from "./TeamAgencyPermission.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamAgencyPermission.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Settings/TeamAgencyPermission.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b1925938"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b1925938', __exports__)) {
    api.reload('b1925938', __exports__)
  }
  
  module.hot.accept("./TeamAgencyPermission.vue?vue&type=template&id=b1925938", () => {
    api.rerender('b1925938', render)
  })

}


export default __exports__